import * as React from "react";
import {FormBodyProps} from "../../../common/props/FormBodyProps";
import SectionView from "../../../layout/section/SectionView";
import InputFormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/InputFormGroup";
import DictionarySortableItemForm from "./DictionarySortableItemForm";

export default class DictionarySortableItemFormBody extends React.PureComponent<FormBodyProps<DictionarySortableItemForm>, {}> {
	render() {
		return (
			<SectionView>
				<div className={"c-create-acquisition-channel"}>
					<InputFormGroup label="Item name"
									placeholder="Enter name"
									field={this.props.form.name}
									onChange={this.props.onFieldChange}
									focus={this.props.form.hasFocus(this.props.form.name)}/>
				</div>
			</SectionView>
		);
	}
}
